import * as types from './actionTypes';
import genreService from '../services/genreService';
import { fetch, addTask } from 'domain-task';

export function getGenres() {
    return (dispatch, getState) => {
        const genres = getState().genres;
        if(genres.length == 0) {        
            let fetchTask = genreService.getGenres()
                .then(genres => {
                    if(genres) {
                        dispatch({ type: types.GET_GENRES, genres });                        
                    }
                    return genres;                    
                })
                .catch(error => {
                    throw(error);
                });
            addTask(fetchTask);
            return fetchTask;
        }
        else {
            return new Promise((resolve, reject) => resolve(genres));
        }
    };
}

/*export function getGenresThenDispatch(callback, action) {
    return (dispatch, getState) => {
        debugger;
        const genres = getState().genres;
        if(genres.length == 0) {        
            let fetchTask = genreService.getGenres()
                .then(genres => {
                    debugger;
                    if(genres) {
                        dispatch({ type: types.GET_GENRES, genres });                        
                    }
                    return genres;                    
                })
                .then(genres => {
                    if(callback) {
                        //wait for the further action
                        callback(genres);    
                        return '';                    
                    }
                })
                .then(val => {

                })
                .catch(error => {
                    throw(error);
                });
            addTask(fetchTask);
        }
        else if(callback) {
            callback(genres);
        }
    };
}*/